import { X, Phone, MessageCircle, MessagesSquare } from 'lucide-react';
import './ContactModal.css';

const CONTACT_TEL = 'tel:+17864008220';
const CONTACT_SMS = 'sms:+17864008220';
const CONTACT_WHATSAPP_URL = 'https://wa.me/17864008220';

function ContactModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="contact-modal-topbar">
          <span className="contact-modal-topbar-spacer" aria-hidden="true" />
          <h2 className="contact-modal-top-title">Contact</h2>
          <button type="button" className="contact-modal-close" onClick={onClose} aria-label="Close">
            <X size={24} />
          </button>
        </div>

        <div className="contact-modal-header">
          <p className="contact-modal-subtitle">
            Choose how to reach us — call, text (SMS), or WhatsApp
          </p>
        </div>

        <div className="contact-modal-actions">
          <a href={CONTACT_TEL} className="contact-modal-action-btn contact-modal-action-btn--call">
            <Phone size={22} aria-hidden="true" />
            <span>Call now</span>
          </a>
          <a href={CONTACT_SMS} className="contact-modal-action-btn contact-modal-action-btn--sms">
            <MessagesSquare size={22} aria-hidden="true" />
            <span>Text (SMS)</span>
          </a>
          <a
            href={CONTACT_WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-modal-action-btn contact-modal-action-btn--whatsapp"
          >
            <MessageCircle size={22} aria-hidden="true" />
            <span>WhatsApp</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactModal;
